function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_128",
  "data-name": "Group 128",
  transform: "translate(-563 -94)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 563, 94)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_160-2",
  "data-name": "Ellipse 160",
  transform: "translate(9 6)",
  fill: "rgba(255,255,255,0)",
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "bg",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "arrow",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "ctrl-right",
  transform: "translate(593.533 112.033) rotate(90)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_129",
  "data-name": "Group 129"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_130",
  "data-name": "Group 130"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M8,1l5.067,6.966L8,14.933",
  transform: "translate(-8 -1)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
})))));

function SvgCircleDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDown);
export default __webpack_public_path__ + "static/media/circle-down.762f309d.svg";
export { ForwardRef as ReactComponent };